import { Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC } from 'react'

import PlaceholderImg from 'images/empty-client-accounts.png'
import { NewClientAccountButton } from 'views/Settings/ClientAccounts'

const EmptyClientAccounts: FC<{ onAccountCreation: () => void }> = ({ onAccountCreation }) => {
    return (
        <Box
            sx={{
                backgroundColor: `Surface300`,
                height: '100vh',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    maxWidth: '900px',
                    height: '680px',
                    margin: 'auto',
                    p: 4,
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        height: '350px',
                        backgroundImage: `url("${PlaceholderImg}")`,
                        backgroundPosition: 'top',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                    }}
                />
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <Text variant={'h5'} sx={{ mb: 1 }}>
                        Nothing to show here yet
                    </Text>
                    <Text
                        variant={'body2'}
                        sx={{
                            mb: 3,
                            textAlign: 'center',
                            maxWidth: '620px',
                        }}
                    >
                        Client accounts will appear here as soon as you add them. Once created,
                        you’ll be able to view activity, metrics and manage settings.
                    </Text>
                    <NewClientAccountButton
                        onModalClose={(created) => {
                            if (created) {
                                onAccountCreation()
                            }
                        }}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default EmptyClientAccounts
